import { render, staticRenderFns } from "./ai-pill.vue?vue&type=template&id=0a2e11a0&scoped=true"
import script from "./ai-pill.vue?vue&type=script&lang=js"
export * from "./ai-pill.vue?vue&type=script&lang=js"
import style0 from "./ai-pill.vue?vue&type=style&index=0&id=0a2e11a0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2e11a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/frontend_src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a2e11a0')) {
      api.createRecord('0a2e11a0', component.options)
    } else {
      api.reload('0a2e11a0', component.options)
    }
    module.hot.accept("./ai-pill.vue?vue&type=template&id=0a2e11a0&scoped=true", function () {
      api.rerender('0a2e11a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ai-pill.vue"
export default component.exports